export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto text-center">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">关于我们</h2>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">了解桃花视频的平台理念与服务承诺</p>
        <div className="bg-background-50 rounded-xl p-6 md:p-8 text-left">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-4">
            桃花视频 — 聚合全网优质影视资源
          </h3>
          <div className="text-sm text-foreground-500 leading-relaxed space-y-3">
            <p>
              桃花视频致力于打造一站式影视聚合平台，汇集红桃视频、樱桃视频、茄子视频、糖心视频、榴莲视频、桃子视频等主流视频平台优质内容资源，为用户提供全面、便捷、高清的在线观影体验。
            </p>
            <p>
              平台以"聚合优质内容，畅享高清观影"为核心理念，每日同步更新最新电视剧、热门电影、人气综艺与动漫新番。无需注册、无需付费，打开浏览器即可畅享全网热播内容，真正做到即开即看、流畅不卡顿。
            </p>
            <p>
              桃花视频采用先进的智能 CDN 加速技术与自适应码率方案，确保不同网络环境下均能获得流畅高清的播放体验。我们持续优化平台性能，扩展内容覆盖范围，力求成为用户追剧观影的首选入口。
            </p>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-background-200">
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-primary-600">10W+</div>
              <div className="text-xs text-foreground-400 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-accent-600">6</div>
              <div className="text-xs text-foreground-400 mt-1">平台聚合</div>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-secondary-600">24h</div>
              <div className="text-xs text-foreground-400 mt-1">实时更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}